import { configureStore } from "@reduxjs/toolkit";
import headerSlice from "../features/headerSlice";
import psikotesSlice from "../features/psikotesSlice";
import authUserSlice from "../features/authUserSlice";
import authAdminSlice from "../features/authAdminSlice";
import searchSlice from "../features/searchSlice";

const combinedReducer = {
  auth: authUserSlice,
  authAdmin: authAdminSlice,
  header: headerSlice,
  psikotesNavbar: psikotesSlice,
  searchSlice: searchSlice,
};

export default configureStore({
  reducer: combinedReducer,
});
